import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(() => ({
  button: ({ sorted }: { sorted: boolean }) => ({
    color: colors.black,
    marginLeft: 0,
    fontSize: 14,
    textDecoration: "none",
    textTransform: "none",
    "&:hover": {
      textDecoration: "none",
      color: colors.black,
    },
    "&:hover svg": {
      opacity: sorted ? 1 : 0.5,
    },
    "& svg": {
      opacity: sorted ? 1 : 0,
    },
    minWidth: 0,
    padding: "2px 8px",
  }),
  cell: {
    paddingLeft: 8,
  },
  buttonIcon: {
    marginLeft: 5,
    width: 14,
  },
}));

export default useStyles;
